import React from "react";

interface IconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
  withText?: boolean;
}

const WindForward: React.FC<IconProps> = ({
  className = "",
  withText = false,
}) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 89 89"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="m47.766 26.738 11.7-11.7-11.7-11.702"
        stroke="#fff"
        strokeWidth={6.326}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M73.257 45.372a30.337 30.337 0 1 1-30.338-30.337h16.548"
        stroke="#fff"
        strokeWidth={6.326}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {withText && (
        <path
          d="M37.188 56.357h-3.29V40.47l-4.851 1.658v-2.786l7.72-2.84h.42v19.856Zm19.775-8.331c0 2.845-.535 4.992-1.604 6.442-1.06 1.44-2.677 2.161-4.852 2.161-2.138 0-3.75-.702-4.838-2.106-1.078-1.414-1.631-3.502-1.658-6.266v-3.425c0-2.845.53-4.979 1.59-6.401 1.069-1.423 2.695-2.134 4.879-2.134 2.166 0 3.778.693 4.839 2.08 1.069 1.386 1.617 3.46 1.644 6.224v3.425Zm-3.303-3.697c0-1.857-.253-3.216-.76-4.077-.508-.87-1.314-1.305-2.42-1.305-1.078 0-1.871.412-2.378 1.237-.508.815-.775 2.093-.802 3.833v4.485c0 1.848.258 3.225.774 4.131.517.906 1.328 1.36 2.433 1.36 1.06 0 1.844-.417 2.352-1.25.507-.843.774-2.157.801-3.942v-4.472Z"
          fill="#fff"
        />
      )}
    </svg>
  );
};

const MemoWindForward = React.memo(WindForward);
export default MemoWindForward;
